export default __webpack_public_path__ + "static/media/img_declaration_benefit2.3829044e.svg";